import React, { useEffect, useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ClientInfoModel, ClientMenuOptionModel } from './../model/clitent-model';
import checkAuthController from '../../../layouts/dashboard/controllers/check-auth.controller';
import { UserInfoModel } from '../../user/models/user.model';
import { RoleChecker } from '../../../utils/role-check-utils';
function ClientMenuOption({ listMenu, userData }: { listMenu: ClientMenuOptionModel[], userData: ClientInfoModel }) {
    const checkUser = checkAuthController();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        checkUser.getLoginUser();
    }, []);

    const user: UserInfoModel | null = checkUser.loginUser;

    return (
        <div>
            <Button
                sx={{ borderRadius: 28 }}
                aria-owns={anchorEl ? 'simple-menu' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon color={"inherit"} />
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {listMenu?.map((menu: ClientMenuOptionModel, key: number) => (<MenuItem disabled={RoleChecker(user) > 1 && key == 2} key={key} onClick={() => {
                    handleClose();
                    menu.onPressed(userData);
                }}>{menu.title}</MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default ClientMenuOption;